export const ROOT_CELL_WIDTH = {
  ICON: 40,
  BAR: 200,
  CONTENT: 500,
  CONTENT_PROJECT_LIST: 300,
} as const;

export const CONTENT_CELL_WIDTH = {
  NAME: 200,
  EXPRESSION: 200,
  DATE: 100,
  UNIT: 100,
  LABEL: 75,
  METRICS: 60,
  OWNER: 60,
  ICON: 40,
  ICON_LARGE: 48,
  ICON_METRIC: 30,
  ICON_KEBAB: 20,
  ICON_LOCK: 16,
} as const;

/**
 * Root widths (these are related to each other).
 * So if content grows 300px bar grows 100px
 */
export const ROOT_CELL_WIDTH_RESPONSIVE = {
  CONTENT: 3,
  CONTENT_PROJECT_LIST: 1,
  BAR: 1,
  ICON: 0,
} as const;

/**
 * How much each cell should grow in relation to the others in content cell
 */
export const CONTENT_CELL_WIDTH_RESPONSIVE = {
  ICON: 0,
  ICON_LOCK: 0,
  NAME: 2,
  RECIPE: 1,
  EXPRESSION: 1.2,
  UNIT: 0,
  ACTIONS: 0.2,
} as const;

export const ELEMENT_CO2_BAR_HEIGHT = 6;
export const ELEMENT_COST_BAR_HEIGHT = 1;
export const PROJECT_CO2_BAR_HEIGHT = 25;
export const PRODUCT_CO2_BAR_HEIGHT = 25;

/**
 * Unified cap for number of proposal bars rendered per row/header
 */
export const MAX_VISIBLE_PROPOSALS = 5;

/**
 * Size in pixels of one indentation level in the list
 */
export const LIST_INDENTATION_SIZE = 30;

export const LIST_ITEM_HEIGHT = 47;
export const LIST_ITEM_HEIGHT_XL = 62;

/**
 * Spacing in the list (in UI units, not pixels)
 */
export const LIST_SPACING = {
  DEFAULT: 2,
  PROJECT_LIST: 8,
} as const;
